import React from "react";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";

const ReviewRatingStar = ({ rating }) => {
  return (
    <Rating
      size="small"
      name="text-feedback"
      value={rating}
      readOnly
      precision={0.5}
      emptyIcon={<StarIcon fontSize="inherit" color="gray" />}
      sx={{ paddingTop: "18px" }}
    />
  );
};

export default ReviewRatingStar;
